import { render, staticRenderFns } from "./OrderablePreviewSections.vue?vue&type=template&id=5ef27cd4&"
import script from "./OrderablePreviewSections.vue?vue&type=script&lang=ts&"
export * from "./OrderablePreviewSections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports